import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useTranslation } from 'react-i18next'

export const useAreaValidationSchema = () => {
	const { t } = useTranslation()

	const boothSchema = yup.object({
		booth: yup
			.object({
				label: yup
					.string()
					.matches(/^[0-9]*$/, t('Only numbers'))
					.required(t('This field is required'))
			})
			.required(t('This field is required'))
	})

	return yupResolver(boothSchema)
}
